"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GZDLabeler = void 0;
const GridLabel_1 = require("../grid/GridLabel");
const GridLabeler_1 = require("../grid/GridLabeler");
const MGRS_1 = require("../MGRS");
/**
 * Grid Zone Designator labeler
 */
class GZDLabeler extends GridLabeler_1.GridLabeler {
    constructor(enabled, minZoom = 0, maxZoom, color, textSize, buffer) {
        super(enabled, minZoom, maxZoom, color, textSize, buffer);
    }
    /**
     * {@inheritDoc}
     */
    getLabels(gridType, zone) {
        const labels = [];
        const bounds = zone.getBounds();
        const center = bounds.getCentroid();
        labels.push(new GridLabel_1.GridLabel(zone.getName(), center, bounds, gridType, MGRS_1.MGRS.from(center)));
        return labels;
    }
}
exports.GZDLabeler = GZDLabeler;
//# sourceMappingURL=GZDLabeler.js.map